'use strict';
var LayoutType;
(function (LayoutType) {
    LayoutType["List"] = "list";
    LayoutType["Grid"] = "grid";
    LayoutType["Masonry"] = "masonry";
})(LayoutType || (LayoutType = {}));
export default LayoutType;
